import * as React from "react";

const StagingAuthContext = React.createContext({
	isLoggedIn: false,
	setIsLoggedIn: (state: boolean) => {},
});
StagingAuthContext.displayName = "StagingAuthContext";
export default StagingAuthContext;
type StagingAuthProviderProps = {
	children: React.ReactElement;
};
export function StagingAuthProvider({ children }: StagingAuthProviderProps) {
	const [isLoggedIn, setIsLoggedIn] = React.useState<boolean>(false);
	return (
		<StagingAuthContext.Provider
			value={{
				isLoggedIn,
				setIsLoggedIn,
			}}
		>
			{children}
		</StagingAuthContext.Provider>
	);
}
